import type { NewsCategory } from "../types/news";

export const newsCategories: NewsCategory[] = [
  {
    slug: "guanxuan",
    name: "官宣恋情",
    desc: "当事人大方公开、工作室盖章确认的感情线动态，从初见路透到正式官宣全覆盖。",
    icon: "ri-heart-3-line",
    accent: "primary",
  },
  {
    slug: "fenshou",
    name: "分手撕扯",
    desc: "感情生变、取关清空、隔空喊话，双方节奏与时间线一次理清。",
    icon: "ri-emotion-unhappy-line",
    accent: "secondary",
  },
  {
    slug: "huifu",
    name: "回应声明",
    desc: "工作室与本人发声、长文回应、律师函动态，看各方到底怎么说。",
    icon: "ri-megaphone-line",
    accent: "accent",
  },
  {
    slug: "fanche",
    name: "翻车现场",
    desc: "言行打脸、口碑反噬、直播失言等突发状况，第一时间跟住后续。",
    icon: "ri-alarm-warning-line",
    accent: "primary",
  },
  {
    slug: "juzu",
    name: "剧组风云",
    desc: "换角、加戏、番位、路透与片场花絮，围绕作品台前幕后的那些事。",
    icon: "ri-clapperboard-line",
    accent: "accent",
  },
  {
    slug: "lutu",
    name: "动态路透",
    desc: "机场、片场、私底下被拍到的日常瞬间，真实状态一览。",
    icon: "ri-roadster-line",
    accent: "secondary",
  },
];